import React, { useState } from 'react';
import * as Icon from "react-bootstrap-icons";
import { uploadMultipleAssetContent,uploadAssetContent } from "../../redux/actions/chatAiActions";
import Toast from "../../components/assetLibComponents/shared/Toast";
import pdfImage from "../../assets/doc_img.png"
import docImage from "../../assets/doc_img_blue.png"
import textImage from "../../assets/doc_img_black.png"
import csvImage from "../../assets/csv.png"
import Loading from "../../assets/up.gif";
import dotLoading from "../../assets/dot.gif";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ceil } from 'lodash';
import { Mixpanel } from '../../Mixpanel';
import { useNavigate } from 'react-router-dom';

// drag drop file component
const FileUploadComponent = (props) => {
  const navigate = useNavigate();

  // drag state
  const dispatch = useDispatch();
  const authToken = props.authToken;
  const isLoading = useSelector((state) => state.chatAi.upload_loading);
  const [dragActive, setDragActive] = useState(false);
  // const [dragZone, setDragZone] = useState(false);
  const [theArray, setTheArray] = useState([]);
  const [actualArray, setActualArray] = useState([]);
  const [dropLoader, setDropLoader] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [header, setHeader] = useState([]);
  // ref
  const inputRef = React.useRef(null);
  
  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
      // props.openDragZone(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  
  const imageSelector = (text) => {
    let name = text.toUpperCase();
    if (name.includes(".CSV")) {
      return csvImage;
    } else {
      return csvImage;
    }
  }

  
  const submitHandler = async () => {
    const data = {
      actualArray:actualArray,
      header:header,
    }

    navigate(`/Lead-Management/leadMapping`, { state:data })
    // if (actualArray.length > 0) {
    //   // Mixpanel.track('Uploaded an asset',
    //   // {"Uploaded an asset Count": actualArray.length});
      
    //   const maxObject = await actualArray.reduce((max, obj) => (obj.doc_url.file.size > max.doc_url.file.size ? obj : max), actualArray[0]);

    //   actualArray.map(async (item, index) => {
    //     props.resetCounter();
    //     await dispatch(uploadAssetContent(authToken, item, index, actualArray.length, maxObject?.doc_url?.file?.size));
    //     if (maxObject?.doc_url?.file?.size === item?.doc_url?.file?.size) {
    //       setActualArray([]);
    //       setTheArray([]);
    //     }
    //   })
    // } else {
    //   Toast("Upload The Documents", "E");
    // }
  }
  
  const fileSizeCalc = (number) => {
    let num = number / 1024;
    if (num < 999) {
      return `${Math.ceil(num)}Kb`;
    } else {
      return `${Math.ceil(num / 1024)}Mb`;
    }
  }
  
  // triggers when file is dropped
  const handleDrop = async function (e) {
      e.preventDefault();
      e.stopPropagation();
      setDragActive(false);
      setDropLoader(true);
      // console.log(e.dataTransfer.files,"Abhishel")

      const file = e.dataTransfer.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        // Read the contents of the file
        const contents = e.target.result;
        
        // Split the contents into lines
        const lines = contents.split('\n');

        // Extract the header (assuming it's the first line)
        const csvHeader = lines[0].split(',');

        // Remove any leading/trailing spaces from header values
        const cleanedHeader = csvHeader.map((header) => header.trim());

        // Set the header state
        setHeader(cleanedHeader);

        // Process the rest of the data (if needed)
        const csvData = lines.slice(1).map((line) => line.split(','));

        // Set the data state
        setCsvData(csvData);
      };

      // Read the file as text
      reader.readAsText(file);
    }

      if (e.dataTransfer.files) {
          // setTheArray([]);
          // generateThumbnail(e.dataTransfer.files)
          let a = e.dataTransfer.files;
          const objArray = await Object.values(a);
          if (objArray?.length > 1 || (objArray?.length + theArray?.length) > 1) {
            setDropLoader(false);
            setDragActive(false);
            props.openDragZone(false);
            Toast("Maximum 1 Document Allowed", "E");
            return;
          }

          let arrayData = [];
          objArray.map((file,file_index) => {
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = (e) => {
                let doc_array;
                doc_array = {
                  doc_url: {
                      base64: reader.result,
                      file: {
                          name: file.name,
                          size: file.size,
                          type: file.type
                      },
                  },
                  id: file_index+theArray?.length,
                  title: file.name,
                  context: "",
                  description: "",
                  client_asset_id: "0"
                }
                if (doc_array?.doc_url?.file?.size > 15728640) {
                  Toast(`"${doc_array?.doc_url?.file?.name}" file size should be smaller than 15 MB`,"E");
                  props.openDragZone(false);
                  setDropLoader(false);
                  return;
                }
                let name = file.name.toUpperCase();
                let charNum = name.lastIndexOf(".");
                if (name.includes(".PDF") || name.includes(".DOCX") || name.includes(".TXT") || name.includes(".CSV")) {
                  setTheArray((prevArr) => [...prevArr, doc_array]);
                  arrayData.push(doc_array);     
                } else {
                  props.openDragZone(false);
                  setDropLoader(false);
                  Toast(`${name.substring(charNum+1)} file not allowed`,"E");
                }
                return arrayData;
              };
          })
        inputRef.current.value = null;
      }
    };
  
    useEffect(() => {
      dispatch({ type: "UPLOAD_LOADING", payload: false});
    }, [])
    
  

  useEffect(() => {
      props.openDragZone(false);
      // setTimeout(() => {
        setActualArray(theArray);
        setDropLoader(false);
      // }, 1000);
    }, [theArray])
    

    const removedocument = async (objId) => {
      setDropLoader(true);
      const newArray = [...theArray];
      const filteredArray = await newArray.filter((item) => {
        return item.id !== objId.id
      });
      setTheArray(filteredArray);  
  }
  
  const updateColClass = (flag) => {
    if (flag !== 0) {
      return "w-3/4 "
    } else {
      return "w-full "
    }
  }
    
    // triggers when file is selected with click
  const handleChange = async function (e) {
        e.preventDefault();
        setDropLoader(true);
        console.log(e?.target?.files,"Abhishel")
        const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        // Read the contents of the file
        const contents = e.target.result;
        
        // Split the contents into lines
        const lines = contents.split('\n');

        // Extract the header (assuming it's the first line)
        const csvHeader = lines[0].split(',');

        // Remove any leading/trailing spaces from header values
        const cleanedHeader = csvHeader.map((header) => header.trim());

        // Set the header state
        setHeader(cleanedHeader);

        // Process the rest of the data (if needed)
        const csvData = lines.slice(1).map((line) => line.split(','));

        // Set the data state
        setCsvData(csvData);
      };

      // Read the file as text
      reader.readAsText(file);
    }

        if (e?.target?.files) {
          let a = e.target.files;
          const objArray = await Object.values(a);
          if (objArray?.length > 1 || (objArray?.length + theArray?.length) > 1) {
            setDropLoader(false);
            Toast("Maximum 1 Document Allowed", "E");
            return;
          }
          let arrayData = [];
          objArray.map((file,file_index) => {
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = (e) => {
                let doc_array;
                doc_array = {
                  doc_url: {
                      base64: reader.result,
                      file: {
                          name: file.name,
                          size: file.size,
                          type: file.type
                      },
                  },
                  id: file_index+theArray?.length,
                  title: file.name,
                  context: "",
                  description: "",
                  client_asset_id: "0"
                }
                if (doc_array?.doc_url?.file?.size > 15728640) {
                  Toast(`"${doc_array?.doc_url?.file?.name}" file size should be smaller than 15 MB`,"E");
                  props.openDragZone(false);
                  setDropLoader(false);
                  return;
                }
                let name = file.name.toUpperCase();
                let charNum = name.lastIndexOf(".");
                if (name.includes(".CSV")) {
                  setTheArray((prevArr) => [...prevArr, doc_array]);
                  arrayData.push(doc_array);     
                } else {
                  props.openDragZone(false);
                  setDropLoader(false);
                  Toast(`${name.substring(charNum+1)} file not allowed`,"E");
                }
                return arrayData;
              };
          })
          inputRef.current.value = null;
        }
    };

    console.log(header,"sacsffsnui")
  
  return (
    <>
      <form id="form-file-upload" className={'w-full flex items-center justify-center rounded-lg border-2 border-dashed border-gray-300 ' + (dragActive === true ? "absolute z-[99] xl:h-[72vh] md:h-[65vh] h-[65vh] left-0 bg-[#F3F4F6] ":"relative h-24 max-sm:h-32 bg-transparent")} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
      <input ref={inputRef} type="file" id="input-file-upload" className='hidden' multiple={true} onChange={handleChange} />
        <div className='flex flex-wrap w-full justify-center'>
          {actualArray && actualArray?.length > 0 ? <div className={'w-[85%] max-sm:mb-2 max-sm:w-full flex justify-center '+(dropLoader !== false ? ' flex items-center justify-center ':"")+(props.dragZone !== false ? " w-full ":"")}>
            {dropLoader !== false ?
              <img style={{ width: "60px" }} src={dotLoading} alt='Loading' />
              :
              <>
                <label htmlFor="input-file-upload" className='absolute w-[85%] h-full max-sm:w-full max-sm:h-[55%] left-0 top-0 bg-transparent'/>
                {actualArray?.length > 0 && actualArray.map((item, index) => {
                  return (
                    <div className='relative w-[38px] mx-2.5 my-0'>
                      <img className='w-[30px]' title={item.title + " " + fileSizeCalc(item?.doc_url?.file?.size)} src={imageSelector(item.doc_url?.file?.name)} alt="doc" />
                      <span className='text-[7px] text-center block'>{item.title.slice(0, 5) + "..."}</span>
                      <span className='text-[7px] text-center block'>Size:{fileSizeCalc(item?.doc_url?.file?.size)}</span>
                      <Icon.X className='absolute top-[-5px] text-[10px] rounded-[50%] left-0 cursor-pointer bg-gray-900' onClick={(e) => { removedocument(item) }} color='#ffffff' />
                    </div>
                  )
                })
                }
              </>}
          </div>
            :
              <div className={(props.dragZone === true ? "w-full ": updateColClass(actualArray?.length)) + (dropLoader === true && 'flex items-center justify-center')}>
                {dropLoader !== false ?
                  <img className='w-[60px]' src={dotLoading} alt='Loading' />
                  :
                  <>
                    <label htmlFor="input-file-upload" className={"w-100 cursor-pointer " + (dragActive ? "bg-white" : "")}>
                    <span className="text-[#374151] text-sm not-italic font-semibold leading-5mt-2 flex justify-center"><Icon.Upload className="text-xl mx-4 text-[#9CA3AF]" /> Upload File or Drag and Drop</span>
                    </label>
                  </>
                }
                </div>
          }
          {(actualArray?.length > 0 && props.dragZone !== true && dragActive === false) &&
            <div
              className={'w-[15%] max-sm:w-full flex items-center justify-center ' + (props.dragZone === true && "hidden")}
              style={{ borderLeft: props.dragZone === true ? "none" : "1px solid #cbd5e1" }}
            >
              {isLoading !== false ?
                <div className="animate-pulse cursor-pointer w-9/12 flex items-center justify-center bg-[color-mix(in_srgb,var(--brand-primary)_8%,transparent)] text-xs font-semibold text-[var(--brand-primary)] p-3 rounded-[10px] border-transparent hover:no-underline hover:bg-[rgba(24,116,132,0.08)]">
                  Uploading...
                </div>
                :
                <div className="cursor-pointer w-9/12 flex items-center justify-center bg-[color-mix(in_srgb,var(--brand-primary)_8%,transparent)] text-xs font-semibold text-[var(--brand-primary)] p-3 rounded-[10px] border-transparent hover:no-underline hover:bg-[rgba(24,116,132,0.08)]" onClick={submitHandler}>
                  Next
                  <Icon.ChevronDoubleRight color="var(--brand-primary)" className="ml-[5px] cursor-pointer" />
                </div>
              }
            </div>
          }         
        </div> 
      { dragActive && <div id="drag-file-element" className='absolute w-full h-full rounded-2xl inset-0' onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
      </form>
      </>
  );
};

export default FileUploadComponent;